import { render, staticRenderFns } from "./NuevoIncidente.vue?vue&type=template&id=9471511e"
import script from "./NuevoIncidente.vue?vue&type=script&lang=js"
export * from "./NuevoIncidente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports